<template>
	<div class="contact" v-loading ="isLoading" element-loading-background="rgba(255,255,255)">
		<div
			class="buddies_box"
			v-for="(contact, idx) in contactList"
			:key="idx"
			:class="idx % 2 === 0 ? 'background-grey' : 'background-white'"
		>
			<div class="customer-avatar">
				<el-avatar :src="contact.logoUrl"></el-avatar>
				<div class="customer-name">
					{{ computeFullName(contact.lastName, contact.firstName) }}
				</div>
			</div>
			<div class="info">
				<div class="customer-address" v-if="type=='external'">
					{{ contact.current_address || '' }}
				</div>
				<div class="customer-number">{{ contact.telNum }}</div>
				
			</div>
			<div class="callBtn" @click="call(contact)">
				<font-awesome-icon :icon="['fas', 'phone']"/>
				<div class="button-label">通話</div>
			</div>
		</div>
		<div class="pagination" v-if="totalPages > 0" >
			<el-pagination
				layout="prev, pager, next, slot"
				:current-page="page"
        :page-size="pageSize"
				:total="total"
				:pager-count="3"
				:page-sizes="pageSizes"
				@current-change="handlePageChange"
				>
				<span class="page-size el-pagination__sizes" >
					<el-select
						v-model="pageSizeSelect"
						size="mini"
						@change="handleSizeChange"
					>
						<el-option
							v-for="item in pageSizes"
							:key="item"
							:label="getPageSizeLabel(item)"
							:value="item"
						/>
					</el-select>
			  </span>
			</el-pagination>
		</div>
	</div>
</template>

<script>
import api from "@/api"
export default {
	name: "Contacts",
	props: {
		searchText: String,
		type: String,
		active: Boolean
	},
    data() {
		return {
			externalContactList:[],
			internalContactList:[],
			page:1,
			pageSize:10,
			totalPages:0,
			total:0,
			isLoading:true,
			pageSizes:[10, 20, 50, 100, 9999],
			pageSizeSelect:10,
			internalContactsTimer:null,
		};
	},
	computed: {
		contactList() {
			if(this.type =='internal'){
				return this.internalContactList
			}else{
				return this.externalContactList
			}
		}
	},
	watch: {
    active(newVal, oldVal) {
			if(newVal && this.type == 'internal'){
				this.refreshInternalContactWithoutShowLoading()
				this.setInternalContactsInterval()
			}else{
				this.clearInternalContactsInterval()
			}
    }
  },
	mounted(){
		if(this.type == 'external'){
			this.getExternalCustomer()
		}else{
			this.getInternalContact()
			if(this.active){
				this.setInternalContactsInterval()
			}
		}
	},
	beforeDestroy() { 
		this.clearInternalContactsInterval()
	},
	methods: {
		computeFullName(lastName, firstName) {
			if (this.$utils && this.$utils.computeFullName) {
				return this.$utils.computeFullName(lastName, firstName);
			}
			return (lastName || '') + (firstName || '');
		},
		call(item){
			this.$emit('createCall', item['telNum'])
		},
		searchContact(contact, searchText) {
			if (contact) {
				return ((contact.lastName || '') + (contact.firstName || '')).includes(searchText) || (contact.telNum || '').includes(searchText);
			}
			return true;
		},
		getExternalCustomer(){
			this.isLoading = true;
			let params ={
				page:this.page,
				pageSize:this.pageSize
			}
			 const keyword = this.searchText && this.searchText.trim()
			if(keyword){
				params.keyword = keyword
			}
			api.getCustomerInfoByPage(params).then((res)=>{
				if(res.data != 'fail'){
					if(res.data.data){
						let result = res.data.data
						this.totalPages = result.totalPages
						this.total = result.total
						this.externalContactList = result.list
						this.isLoading = false;
					}
				}
			},(err)=>{
				console.log(err);
			})
		},
		getInternalContact(){
			this.isLoading = true;
			this.refreshInternalContactWithoutShowLoading();
		},
		refreshInternalContactWithoutShowLoading(){
			api.getPbxUserStatus().then((res) => {
          if(res.data.result && res.data.result.length){
						this.internalContactList = res.data.result
																				.filter(item => item.presence == 'Online' && item.sipNum != this.$root.user.tel_num)
																				.map(({ sipNum, firstname, lastname, logo, ...rest }) => ({ telNum: sipNum, firstName: firstname, lastName: lastname, logoUrl: logo, ...rest }))
																				.filter(item => this.searchContact(item, this.searchText))													
						this.isLoading = false;
          } else {
						this.internalContactList = [];
						this.isLoading = false;
					}
        }).catch((err) => {
          console.log(err);
					this.isLoading = false;
        })
		},
		handlePageChange(newPage) { 
			this.page = newPage; 
			this.getExternalCustomer(); 
		},
		searchContacts(){
			this.page = 1;
			if(this.type == 'external'){
				this.getExternalCustomer();
			}else{
				this.getInternalContact();
			}	
		},
		handleSizeChange(val){
			if(val === 9999){
				this.pageSize = this.total
			}else{
				this.pageSize = val;
			}
			this.getExternalCustomer();
		},
		getPageSizeLabel(item){
			return (item === 9999 || item == this.total ) ? '全件' : item + '件/ページ'
		},
		setInternalContactsInterval(){
			this.clearInternalContactsInterval();
			this.internalContactsTimer = setInterval(this.refreshInternalContactWithoutShowLoading, 10*1000)
		},
		clearInternalContactsInterval(){
			if (this.internalContactsTimer) { 
				clearInterval(this.internalContactsTimer) 
				this.internalContactsTimer = null 
		  } 
		}
	},
};
</script>

<style lang="scss" scoped>
.contact{
	background: white;
}
.background-grey{
	background: #eeee;
}
.background-white{
	background: white;
}
.pagination{
	text-align: center;
	margin-top: 8px;
	display: flex;
  justify-content: space-between;
	::v-deep .el-pagination .el-select .el-input{
		width: 90px;
		margin: 0px;
	}
	::v-deep .el-select-dropdown__item {
		font-size: 12px;
	}
	::v-deep .el-pagination .el-select .el-input .el-input__inner{
		font-size: 12px;
		padding-left:4px;
		padding-right: 0px;
	}
	::v-deep .el-pagination__sizes {
		margin-right: 0px;
	}
	::v-deep .el-pagination .el-input__inner {
		text-align: left;
	}
}
.buddies_box {
	display: flex;
	align-items: center;
	padding:4px 4px;
	cursor: pointer;
	border-radius: 4px;
	.customer-name{
		font-size:12px;
	}
	.customer-avatar {
		width:70px;
		text-align: center;
	}
	.customer-address{
		line-height: 18px;
    font-size: 12px;
	}
	.customer-number{
		font-size: 12px;
		line-height: 18px;
	}
	::v-deep .el-avatar>img{
		width:100%
	}

	.info {
		margin-left: 10px;
		width: calc(100% - 100px);
	}
	.callBtn {
		background: #34a84f;
    font-size: 14px;
    color: white;
    text-align: center;
    width: 40px;
    padding: 4px;
    border-radius: 4px;
		.button-label{
			font-size: 10px;
		}
	}
}
.buddies_box + .buddies_box {
}
</style>
